export const MOBILE = 'MOBILE';
export const TABLET = 'TABLET';
export const DESKTOP = 'DESKTOP';
export const HUAWEI_WEBVIEW = 'HUAWEI_WEBVIEW';
